import { UnitRead } from "@types";
import { STRING } from "@constants";

const T = STRING.UNIT_DETAILS;

export function getUnitDetailsSections(data?: UnitRead | null) {
  if (!data) return { sections: [] };

  const sections: any[] = [];

  if (data.size?.imageUrl) {
    sections.push({
      type: "image",
      title: "Unit Image",
      icon: "pi-image",
      src: data.size.imageUrl,
      alt: `Image of ${data.size.description}`,
    });
  }

  sections.push({
    title: T.GENERAL_INFO,
    icon: "pi-box",
    fields: [
      { label: T.STATUS, value: data.status },
      { label: T.CONDITION, value: data.condition },
      { label: T.TYPE, value: data.type },
      { label: T.SORT_ID, value: data.sortId },
      { label: T.NOTES, value: data.notes ?? "None" },
    ],
  });

  sections.push({
    title: T.DESCRIPTION,
    icon: "pi-align-justify",
    fields: [
      {
        label: T.DESCRIPTION_1,
        value: data.unitDescription?.description1 ?? "N/A",
      },
      {
        label: T.DESCRIPTION_2,
        value: data.unitDescription?.description2 ?? "N/A",
      },
      {
        label: T.DESCRIPTION_3,
        value: data.unitDescription?.description3 ?? "N/A",
      },
      {
        label: T.DESCRIPTION_4,
        value: data.unitDescription?.description4 ?? "N/A",
      },
    ],
  });

  sections.push({
    title: "Unit Size",
    icon: "pi-expand",
    fields: [
      { label: "Description", value: data.size?.description ?? "N/A" },
      { label: "Width", value: data.size?.width ?? "N/A" },
      { label: "Length", value: data.size?.length ?? "N/A" },
    ],
  });

  sections.push({
    title: "Location",
    icon: "pi-map-marker",
    fields: [
      { label: "Name", value: data.location?.locationName ?? "N/A" },
      { label: "Address", value: data.location?.address ?? "N/A" },
      { label: "City", value: data.location?.city ?? "N/A" },
      { label: "State", value: data.location?.state ?? "N/A" },
      { label: "Zip Code", value: data.location?.zipCode ?? "N/A" },
    ],
  });

  return { sections };
}
